import { AuthUserService } from '../auth/auth-user.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { DocumentReference } from '@firebase/firestore-types';
import { Injectable } from '@angular/core';
import { Invite, Invites } from './invite.model';
import { NfmbDataService } from '../nfmb-data.service';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { Profiles } from '../profiles/profile.model';
import { switchMap, shareReplay, first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InviteService extends NfmbDataService {

  private groupFilter$: BehaviorSubject<string|null>;

  constructor(
    afs: AngularFirestore,
    authUserService: AuthUserService
    ) {
    super(afs, authUserService, 'invites');
    this.groupFilter$ = new BehaviorSubject(null);

    this.permissions = {
      edit: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN,
      ],
      delete: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN
      ],
      read: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN
      ]
    };
  }

  get data$(): Observable<any> {
    return combineLatest([
      this.groupFilter$,
      this.authUserService.currentProfile$
    ]).pipe(
      switchMap( ([group, profile]) => {
        if (profile) {
          return this.afs.collection<Invite>(this.collectionPath,
            ref => {
              console.log('Profile Stream emit new value for following group and profile: ', { group, profile });
              let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
              query = query.where('organizationId', '==', profile.organizationId);
              if (group) { query = query.where(Invites.IndexField.GROUPS, 'array-contains', group); }
              query = query.orderBy(Invites.IndexField.FIRST_NAME, 'desc');
              return query;
            }
          ).valueChanges({ idField: 'id' });
        } else {
          return [];
        }
      }),
      shareReplay(1)
    );
  }

  async push(item: any): Promise<DocumentReference> {
    const currentProfile = await this.authUserService.currentProfile$.pipe(first()).toPromise();
    if (!(currentProfile && currentProfile.organizationId)) {
      return Promise.reject('user not authorized');
    }
    const timestamp = this.timestamp;
    return this.afs.collection<Invite>(this.collectionPath).add({
      ...item,
      organizationId: currentProfile.organizationId,
      createdAt: timestamp,
      modifiedAt: timestamp,
    });
  }

  public filterByGroup(group: string): void {
    return this.groupFilter$.next(group);
  }

  public resetPublicFilters(): void {
    return this.groupFilter$.next(null);
  }
}
